import { render } from "./NowPlayingView.vue?vue&type=template&id=185c35fa&scoped=true"
import script from "./NowPlayingView.vue?vue&type=script&lang=js"
export * from "./NowPlayingView.vue?vue&type=script&lang=js"

import "./NowPlayingView.vue?vue&type=style&index=0&id=185c35fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185c35fa"]])

export default __exports__